import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=31509971&scoped=true&"
import script from "./BaseText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=31509971&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31509971",
  null
  
)

export default component.exports